import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NetworkCallService } from '../../../../../src/app/core/services/network-call.service';
import { fromSwitchToAnotherBusinessProfileActions } from '../actions';
import { ISwitchBusinessProfileRequest, ISwitchBusinessProfileResponse } from '../models/switch-to-another-business-profile.model';
import { mergeMap, catchError, switchMap } from 'rxjs/operators';
import { retryTransientHttpErrors } from '../../../core/operators/retry-transient-http-error.operator';
import { of } from 'rxjs';
import { HelpersService } from '../../../core/services/helpers.service';

@Injectable()
export class SwitchToAnotherBusinessProfileEffects {
  constructor(
    private actions$: Actions,
    private networkCallService: NetworkCallService,
    private router: Router,
    private helperService: HelpersService
  ) {}

  logout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromSwitchToAnotherBusinessProfileActions.loadSwitchToAnotherBusinessProfiles),
      switchMap(action =>
        this.networkCallService
          .post<
            ISwitchBusinessProfileRequest,
            ISwitchBusinessProfileResponse
          >('Authentication/switchToAnotherBusinessProfile', action.request)
          .pipe(
            mergeMap(response => {
              sessionStorage.setItem('token', response.accessToken);
              sessionStorage.setItem('refreshToken', response.refreshToken);
              this.router.navigateByUrl('business-detail');
              return [fromSwitchToAnotherBusinessProfileActions.loadSwitchToAnotherBusinessProfilesSuccess({ response })];
            }),
            retryTransientHttpErrors(),
            catchError(error => {
              return of(fromSwitchToAnotherBusinessProfileActions.loadSwitchToAnotherBusinessProfilesFailure(error));
            })
          )
      )
    )
  );
}
